var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSearchModal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icSearchModal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Inbox---Search-/-Filter",
    transform: "translate(-30.000000, -223.000000)",
    stroke: "#666666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.000000, 158.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(28.000000, 73.500000) scale(-1, 1) translate(-28.000000, -73.500000) translate(20.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37321137,12.4104854 C3.33853132,12.4104854 0.86954813,9.9667039 0.86954813,6.96182199 C0.86954813,3.95772815 3.33853132,1.51394667 6.37321137,1.51394667 C9.40789142,1.51394667 11.8768746,3.95772815 11.8768746,6.96182199 C11.8768746,9.9667039 9.40789142,12.4104854 6.37321137,12.4104854 M10.6780265,11.2118425 C11.7756931,10.1219522 12.456369,8.61911721 12.456369,6.96182199 C12.456369,3.64171513 9.72753314,0.940237242 6.37321137,0.940237242 C3.01888959,0.940237242 0.290053784,3.64171513 0.290053784,6.96182199 C0.290053784,10.2827169 3.01888959,12.9841948 6.37321137,12.9841948 C7.84570957,12.9841948 9.19709652,12.4632856 10.2503045,11.5987811 L14.564318,16.0403008 C14.621041,16.0994055 14.6969271,16.1285638 14.7735798,16.1285638 C14.8456333,16.1285638 14.9176869,16.1017696 14.9744099,16.0481814 C15.0893889,15.9386407 15.0932215,15.7573864 14.9820751,15.6431173 L10.6780265,11.2118425 Z",
    id: "Stroke-6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchModal);
export default __webpack_public_path__ + "static/media/icSearchModal.e5f7a2d7379068f950b4c9c5ebd79fef.svg";
export { ForwardRef as ReactComponent };